import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  IntProgressionfaq59u1bhfih as IntProgression,
  LongProgression4dpjnpwadpbx as LongProgression,
  CharProgression45cqq4g7w3uj as CharProgression,
} from './Progressions.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  ClosedRangehokgr73im9z3 as ClosedRange,
  OpenEndRange1a2my95ycmxk8 as OpenEndRange,
} from './Range.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  numberToLong2pakxeg38estk as numberToLong,
  shiftRightUnsigned1ga7wnvbv2qur as shiftRightUnsigned,
  multiply2k9eolhnz1bjv as multiply,
  convertToInty04h231mmjoh as convertToInt,
} from '../js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
  Char__plus_impl_qi7pgj3akekecdud2w6 as Char__plus_impl_qi7pgj,
  Char__compareTo_impl_ypi4mbdrkik40uwhqc as Char__compareTo_impl_ypi4mb,
  Char__toInt_impl_vasixd1agw9q2fuvclj as Char__toInt_impl_vasixd,
  toString3o7ifthqydp6e as toString_0,
} from '../Char.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.g2_1 = new (IntRange())(1, 0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var IntRangeClass;
function IntRange() {
  if (IntRangeClass === VOID) {
    class $ extends IntProgression() {
      constructor(start, endInclusive) {
        Companion_getInstance();
        super(start, endInclusive, 1);
      }
      j1() {
        return this.i2_1;
      }
      k1() {
        return this.j2_1;
      }
      lr() {
        if (this.j2_1 === 2147483647) {
          // Inline function 'kotlin.error' call
          var message = 'Cannot return the exclusive upper bound of a range that includes MAX_VALUE.';
          throw IllegalStateException().o4(toString(message));
        }
        return this.j2_1 + 1 | 0;
      }
      mr(value) {
        return this.i2_1 <= value && value <= this.j2_1;
      }
      l2(value) {
        return this.mr(typeof value === 'number' ? value : THROW_CCE());
      }
      i1() {
        return this.i2_1 > this.j2_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof IntRange()) {
          tmp = this.i1() && other.i1() || (this.i2_1 === other.i2_1 && this.j2_1 === other.j2_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.i1() ? -1 : imul(31, this.i2_1) + this.j2_1 | 0;
      }
      toString() {
        return '' + this.i2_1 + '..' + this.j2_1;
      }
    }
    initMetadataForClass($, 'IntRange', VOID, VOID, [IntProgression(), ClosedRange(), OpenEndRange()]);
    IntRangeClass = $;
  }
  return IntRangeClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.nr_1 = new (LongRange())(1n, 0n);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var LongRangeClass;
function LongRange() {
  if (LongRangeClass === VOID) {
    class $ extends LongProgression() {
      constructor(start, endInclusive) {
        Companion_getInstance_0();
        super(start, endInclusive, 1n);
      }
      j1() {
        return this.rr_1;
      }
      k1() {
        return this.sr_1;
      }
      lr() {
        if (this.sr_1 === 9223372036854775807n) {
          // Inline function 'kotlin.error' call
          var message = 'Cannot return the exclusive upper bound of a range that includes MAX_VALUE.';
          throw IllegalStateException().o4(toString(message));
        }
        // Inline function 'kotlin.Long.plus' call
        var this_0 = this.sr_1;
        return add(this_0, fromInt(1));
      }
      ur(value) {
        return this.rr_1 <= value && value <= this.sr_1;
      }
      l2(value) {
        return this.ur(typeof value === 'bigint' ? value : THROW_CCE());
      }
      i1() {
        return this.rr_1 > this.sr_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof LongRange()) {
          tmp = this.i1() && other.i1() || (this.rr_1 === other.rr_1 && this.sr_1 === other.sr_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.i1() ? -1 : convertToInt(add(multiply(numberToLong(31), this.rr_1 ^ shiftRightUnsigned(this.rr_1, 32)), this.sr_1 ^ shiftRightUnsigned(this.sr_1, 32)));
      }
      toString() {
        return this.rr_1.toString() + '..' + this.sr_1.toString();
      }
    }
    initMetadataForClass($, 'LongRange', VOID, VOID, [LongProgression(), ClosedRange(), OpenEndRange()]);
    LongRangeClass = $;
  }
  return LongRangeClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.vr_1 = new (CharRange())(_Char___init__impl__6a9atx(1), _Char___init__impl__6a9atx(0));
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var CharRangeClass;
function CharRange() {
  if (CharRangeClass === VOID) {
    class $ extends CharProgression() {
      constructor(start, endInclusive) {
        Companion_getInstance_1();
        super(start, endInclusive, 1);
      }
      zr() {
        return this.as_1;
      }
      j1() {
        return new (Char())(this.zr());
      }
      ds() {
        return this.bs_1;
      }
      k1() {
        return new (Char())(this.ds());
      }
      es() {
        if (this.bs_1 === _Char___init__impl__6a9atx(65535)) {
          // Inline function 'kotlin.error' call
          var message = 'Cannot return the exclusive upper bound of a range that includes MAX_VALUE.';
          throw IllegalStateException().o4(toString(message));
        }
        return Char__plus_impl_qi7pgj(this.bs_1, 1);
      }
      lr() {
        return new (Char())(this.es());
      }
      fs(value) {
        return Char__compareTo_impl_ypi4mb(this.as_1, value) <= 0 && Char__compareTo_impl_ypi4mb(value, this.bs_1) <= 0;
      }
      l2(value) {
        return this.fs(value instanceof Char() ? value.z2_1 : THROW_CCE());
      }
      i1() {
        return Char__compareTo_impl_ypi4mb(this.as_1, this.bs_1) > 0;
      }
      equals(other) {
        var tmp;
        if (other instanceof CharRange()) {
          tmp = this.i1() && other.i1() || (this.as_1 === other.as_1 && this.bs_1 === other.bs_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        var tmp;
        if (this.i1()) {
          tmp = -1;
        } else {
          // Inline function 'kotlin.code' call
          var this_0 = this.as_1;
          var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
          var tmp_0 = imul(31, tmp$ret$0);
          // Inline function 'kotlin.code' call
          var this_1 = this.bs_1;
          tmp = tmp_0 + Char__toInt_impl_vasixd(this_1) | 0;
        }
        return tmp;
      }
      toString() {
        return toString_0(this.as_1) + '..' + toString_0(this.bs_1);
      }
    }
    initMetadataForClass($, 'CharRange', VOID, VOID, [CharProgression(), ClosedRange(), OpenEndRange()]);
    CharRangeClass = $;
  }
  return CharRangeClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1a3oieudzv4l4,
  CharRange as CharRange1dt3801jgpja5,
  IntRange as IntRange1cx8zvxgibbj2,
  LongRange as LongRange138sb2ngfio7d,
};
//endregion

//# sourceMappingURL=PrimitiveRanges.mjs.map
